export default "__VITE_ASSET__2NlG6kGs__"